module.exports = __webpack_public_path__ + "static/school_support_img3M@2x-077c4b36c7509283bb29c0dd6c6ce3ed.jpg";